import React from 'react';
import './App.scss';
import Header from "./components/Header";
import Chooser from "./components/Chooser";
import foto_1 from "./images/foto_1.jpg"
import foto_2 from "./images/foto_2.jpg"
import foto_3 from "./images/foto_3.jpg"
import foto_9 from "./images/foto_9.jpg"
import foto_10 from "./images/foto_10.jpg"
import foto_11 from "./images/foto_11.jpg"
import ShowOn from "./components/ShowOn";
import Footer from "./components/Footer";

function App() {
  return (
      <>
          <Header/>
          <Chooser/>
          <div className={"container flex"}>
              <img src={foto_1} alt={"foto_1"}/>
              <div className="content">
                  <h2>EUROPEAN COVERAGE</h2>
                  <p>
                      Our experienced crew is ready to perform air taxi flights all across Europe. We are approved to
                      operate in European countries, from Netherlands to Spain, and from Georgia to UK. We'll get you
                      where you need to go.
                  </p>
                  <h2>EXPLORE EUROPE LIKE NEVER BEFORE</h2>
                  <p>
                      Planning a unique vacation with family or friends? We are your ideal choice. Explore multiple
                      destinations in a short time. Visit the picturesque islands of Greece, Spain, or Italy without
                      waiting for regular planes or ferries. Explore different cities across northern Europe in just a
                      week. The possibilities are endless with our air taxi service.
                  </p>
              </div>
          </div>
          <div className="container flex">
              <div className="content">
                  <h2>AIRCRAFT DESIGNED FOR YOUR NEEDS</h2>
                  <p>
                      Our aircraft, designed in the United States, are constructed to handle air taxi flights from a
                      variety of runways. Whether it's grass airfields in the Netherlands or short runways in Germany or
                      France, we save you time and get you to your destination efficiently.
                  </p>
              </div>
              <img src={foto_2} alt="foto_2"/>
          </div>
          <div className={"container flex"}>
              <img src={foto_3} alt="foto_3"/>
              <div className="content">
                  <h2>
                      CUSTOMIZED SIGHTSEEING FLIGHTS
                  </h2>
                  <p>Looking to create unforgettable memories? Opt for our sightseeing flights customized to your
                      preferences. Enjoy breathtaking views from our comfortable cabin with large windows, all at a
                      minimum possible altitude of 150 meters above ground level.</p>
              </div>

          </div>
          <ShowOn/>
          <div className={"information"}>
              <div className="column first">Information <br/>
                  This aircraft is based in Norrköping. <br/>
                  <br/>Piper PA31 is a multi engine aircraft with 6-8 seats depending on model build by Piper Aircraft
                  Inc. In Sweden the PA31 has been a common taxi and business aircraft but it has also been used by both
                  the air force and the marine. The original model of the PA31 is called Navajo. A longer version with
                  room for two extra seats is called Navajo Chieftain (PA31-350)
              </div>
              <div className="column">Airplane facts <br/><br/>
                  Speed: 175 knop /325km/h
                  Altitude: 10 000 feet / 3000 meters
                  Max range: 615 Nm / 1130 km Max takeof weight: 3340 kg Passengers: 8
              </div>
              <div className="column">Estimated flight times <br/> <br/>


                  Goteborg - Stocholm 01:11h <br/>
                  Bergen - Oslo 00:58h <br/>
                  Edinburgh - Stavanger 01:54h <br/>

                  Amsterdam - Malmo 02:01h <br/>
                  Hamburg - Gdansk 01:42h <br/>
                  Norrkoping – Goteborg: 00:40h <br/>
                  Norrkoping – Malmö 01:00h <br/>
                  Norrkoping – Arlanda: 00:30h <br/>
              </div>

          </div>
          <div className={"poster"}>
              <img src={foto_9} alt="foto_9" className={"poster_img"}/>
          </div>
          <div className="container flex">
              <img src={foto_10} alt=""/>
              <div className="content">
                  <h2>FLEXIBLE PASSENGER SALON</h2>
                  <p>Need a unique air taxi experience? Our passenger salon is versatile and can be quickly reconfigured to accommodate your ad-hoc and special requests. Whether it's fast parcel delivery or a custom passenger-cargo load, we're here to make it happen with convenience and speed.


                      TAILORED SOLUTIONS

                      Even if our aircraft doesn't perfectly fit your needs, we'll find the best solution and aircraft for your request. Your satisfaction is our priority.</p>
              </div>
          </div>
          <div className="container flex">
              <div className="content">
                  <h2>SPECIAL OFFERS FOR
                      TRAVEL AGENCIES</h2>
                  <p>Calling all travel agencies! We have special cooperation terms tailored for your needs. Don't hesitate to reach out to us; we're always open to collaboration.</p>
              </div>
              <img src={foto_11} alt="foto_11"/>
          </div>
          <Footer />

      </>
  );
}

export default App;
